import React from "react";
import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import CreateNewsFeedForm from "./forms/CreateNewsFeedForm";


export default function CreateNewsFeed() {
     return (
          <>
               <MainLeftTitle title="Create News Feed"></MainLeftTitle>
               <CreateNewsFeedForm/>
          </>
     );
}
